import React from 'react';
import './ScheduleMonthShell.css';

export function shiftMonth(month, delta) {
  const [y, m] = String(month || '').split('-').map(Number);
  if (!y || !m) return month;
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function monthNow(offset = 0) {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() + offset);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export const SCHEDULE_MONTH_TABS = [
  { key: 'month', label: '本月' },
  { key: 'schedule', label: '排班' },
];

export default function ScheduleMonthShell({
  month,
  onMonthChange,
  tab,
  onTabChange,
  tabs = SCHEDULE_MONTH_TABS,
  children,
}) {
  return (
    <div className="schedule-month-shell">
      <div className="sms-top">
        <div className="sms-month-nav">
          <button type="button" className="sms-btn-ghost" onClick={() => onMonthChange(shiftMonth(month, -1))} aria-label="上個月">◀</button>
          <span className="sms-month-label">上個月</span>
          <input
            type="month"
            className="sms-month-input"
            value={month}
            onChange={(e) => onMonthChange(e.target.value)}
          />
          <span className="sms-month-label">下個月</span>
          <button type="button" className="sms-btn-ghost" onClick={() => onMonthChange(shiftMonth(month, 1))} aria-label="下個月">▶</button>
          <button type="button" className="sms-btn-ghost" onClick={() => onMonthChange(monthNow(0))}>本月</button>
        </div>
        <div className="sms-tabs">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              className={`sms-tab${tab === t.key ? ' on' : ''}`}
              onClick={() => onTabChange(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      <div className="sms-body">{children}</div>
    </div>
  );
}
